import React from 'react';

import { Flex, Skeleton, Button, ExternalLink } from 'src/packages/core';
import { NotificationIcon, NotificationNewIcon, ProfileIcon, SearchIcon } from 'src/packages/icons';

import { HeaderMobileIcons } from '../Header.styles';
import { HeaderUser, QuickSearchDataType, HeaderNotifications } from '../Header.types';
import { goToUrl } from 'src/utils/go-to-url';
import { config } from 'src/config';
import { BurgerMenu } from './BurgerMenu';
import { getBurgerMenuLinks } from '../links';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

interface Props {
  quickSearchData?: QuickSearchDataType;
  user?: HeaderUser;
  userLoading: boolean;
  convertPlatformEnabled: boolean;
  earnPlatformEnabled: boolean;
  tradeSpotPlatformEnabled: boolean;
  tradeDerivativesPlatformEnabled: boolean;
  p2pPlatformEnabled: boolean;
  notifications?: HeaderNotifications;
  openQuickSearchModal: () => void;
  openLoggedUserModal: () => void;
  openLanguagesModal: () => void;
  topNoticeBarHeight?: number;
}

export const HeaderMobileIconsWrapper = ({
  quickSearchData,
  user,
  userLoading,
  p2pPlatformEnabled,
  earnPlatformEnabled,
  tradeSpotPlatformEnabled,
  tradeDerivativesPlatformEnabled,
  convertPlatformEnabled,
  notifications,
  openQuickSearchModal,
  openLoggedUserModal,
  openLanguagesModal,
  topNoticeBarHeight,
}: Props) => {
  const contextTheme = useTheme();
  const { t } = useTranslation();

  if (userLoading) {
    return (
      <HeaderMobileIcons>
        <Skeleton width={'20px'} height={'20px'} theme={'dark'} withBorder={true} />
        <Skeleton width={'20px'} height={'20px'} theme={'dark'} withBorder={true} />
      </HeaderMobileIcons>
    );
  }

  return (
    <HeaderMobileIcons>
      {quickSearchData && (
        <Flex onClick={openQuickSearchModal}>
          <SearchIcon size={20} color={contextTheme.colors.palette.white} />
        </Flex>
      )}

      {!!user && (
        <Flex onClick={openLoggedUserModal}>
          <ProfileIcon size={20} color={contextTheme.colors.palette.white} />
        </Flex>
      )}

      {!user && (
        <Button
          theme='dark'
          minWidth={'75px'}
          variant={'secondarySmall'}
          text={t('button.sign_up')}
          onClick={() => {
            goToUrl(`${config.coinflareUrl}/register`);
          }}
        />
      )}

      <ExternalLink link={config.notificationCenterUrl} ariaLabel='Notifications'>
        {notifications && notifications.unread > 0 ? (
          <NotificationNewIcon color={contextTheme.colors.palette.white} />
        ) : (
          <NotificationIcon color={contextTheme.colors.palette.white} />
        )}
      </ExternalLink>

      <BurgerMenu
        user={user}
        topNoticeBarHeight={topNoticeBarHeight}
        links={getBurgerMenuLinks(
          convertPlatformEnabled,
          earnPlatformEnabled,
          tradeSpotPlatformEnabled,
          tradeDerivativesPlatformEnabled,
          p2pPlatformEnabled
        )}
        openLanguagesModal={openLanguagesModal}
      />
    </HeaderMobileIcons>
  );
};
